/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Settings_Misa_Tax_CodeInputs */

const vi_einvoice_settings_misa_tax_code = /** @type {(inputs: Einvoice_Settings_Misa_Tax_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mã số thuế người bán`)
};

/**

* @param {Einvoice_Settings_Misa_Tax_CodeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_settings_misa_tax_code = /** @type {((inputs?: Einvoice_Settings_Misa_Tax_CodeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Settings_Misa_Tax_CodeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_settings_misa_tax_code(inputs)
});